export enum PasswordStrengthLevel {
  None = 'none',
  Weak = 'weak',
  Medium = 'medium',
  Strong = 'strong',
}

export const PasswordStrengthValues = {
  [PasswordStrengthLevel.None]: 0,
  [PasswordStrengthLevel.Weak]: 1,
  [PasswordStrengthLevel.Medium]: 2,
  [PasswordStrengthLevel.Strong]: 3,
};

export interface PasswordStrengthProps {
  currentLevel: PasswordStrengthLevel;
  error?: string;
}
